import { DateUtils } from 'react-day-picker'
import { parse } from 'utils/date'

export const parseDate = (dateString: string, format: string, langCode: string): Date | undefined => {
  const parsed = parse(dateString, format, langCode)
  return DateUtils.isDate(parsed) ? parsed : undefined
}
